const env = {
  TITLE: "OPU-WAREHOUSE",
  COPYRIGHT: "©2020 桂林奥普计算机网络集团有限公司 技术支持",
  SERVICETEL: ["400-0773-021"],
  SERVICEQQ: "4000773021",
  // API_HOST: "https://am.9dinn.com:9443",
  // FILE_HOST: "https://am.9dinn.com:9443",

  API_HOST: "https://opuapi.zytx.org.cn",

  FILE_HOST: "https://opuapi.zytx.org.cn",

  PUBLICPATH: "/",
  PERMISSION: {
    action: false, //是否开启功能权限验证
  },
};
window.env = env;
export default env;
